// src/features/terminal-auth/api/authApi.js
import httpClient from "../../../shared/api/httpClient";

const AUTH_BASE = "/auth";

export const AuthApi = {
  login: ({ usuario, password, client = "WEB", licenseId, branchId, employeeRoleId }) =>
    httpClient.post(`${AUTH_BASE}/login`, {
      email: usuario,
      password,
      client,
      licenseId: licenseId ?? undefined,
      branchId: branchId ?? undefined,
      employeeRoleId: employeeRoleId ?? undefined,
    }),

  refresh: ({ refreshToken }) => httpClient.post(`${AUTH_BASE}/refresh`, { refreshToken }),

  getMe: () => httpClient.get(`${AUTH_BASE}/me`),

  selectContext: ({ licenseId, branchId, employeeRoleId }) =>
    httpClient.post(`${AUTH_BASE}/select-context`, {
      licenseId,
      branchId,
      employeeRoleId,
    }),

  requestPasswordReset: ({ email }) =>
    httpClient.post("/auth/password-reset/request", { email }),

  confirmPasswordReset: ({ email, code, newPassword }) =>
    httpClient.post("/auth/password-reset/confirm", {
      email,
      code,
      newPassword,
    }),

  listBranchesByLicense: ({ licenseId }) =>
    httpClient.get(`/hr/employee-shifts/branches?licenseId=${licenseId}`),
};

export default AuthApi;